import { type Ref } from "react";
import clsx from "clsx";
import { env } from "@shared/config.ts";
import "./builddocs-iframe.scss";

const BuilddocsIframe = ({
  ref,
  className,
}: {
  ref: Ref<HTMLIFrameElement>;
  className?: string;
}) => {
  return (
    <iframe
      ref={ref}
      id="builddocs-iframe"
      className={clsx("builddocs-iframe", className)}
      src={`${env.OLD_FRONTEND_URL}`}
      title="builddocs-iframe"
    />
  );
};

export default BuilddocsIframe;
